<template>
  <div class='result-compare-component result-component'>
    <div class="result-heading">
      <h2>{{ config.title }}</h2>
    </div>
    <div class="result-circles">
      <result-circle ref='circle1' :score='score1' :max-score='maxScore' :text='score1Text' :progress='progress1' :config='this.config.circles[0]'>
        <template slot='title'>
          <h2>Your score</h2>
        </template>
      </result-circle>
      <div class='result-spacer'>
        <div></div>
      </div>
      <result-circle ref='circle2' :score='score2' :max-score='maxScore' :text='score2Text' :progress='progress2'  :config='this.config.circles[1]'>
        <template slot='title'>
          <h2>Avg score</h2>
        </template>
      </result-circle>
    </div>
    <div class='result-message'>
      <p>{{ message }}</p>
    </div>
    <div class="ranking debug">
      <h2>Debug data</h2>
      {{ result }}
    </div>
    <div class="comp-type">
      <slot name='comptype'></slot>
    </div>
  </div>
</template>
<script>
import ResultCircle from './Circle.vue'
import Scoring from '../lib/Scoring.js'
export default {
  props: ['config', 'result'],
  components: {
    'result-circle': ResultCircle
  },
  mixins: [Scoring],
  data () {
    return {
      maxScore: 0,
      score1: 0,
      score2: 0,
      score1Text: '',
      score2Text: '',
      message: '',
      rank: '',
      key: '',
      progress1: 0,
      progress2: 0,
      scoreBand1: null,
      scoreBand2: null
    }
  },
  methods: {
    update () {
      this.maxScore = this.getMaxScore()
      this.score1 = this.result.comparison.score
      this.progress1 = this.asPercentage(this.score1, this.maxScore)
      this.progress2 = this.asPercentage(this.result.comparison.average_score, this.maxScore)
      this.score1Text = this.displayScore(this.score1, this.maxScore, this.config.circles[0].displayAs)
      switch (this.config.circles[1].displayAs) {
        case 'score':
          this.score2Text = this.displayScore(this.config.circles[1].displayAs)
          break
        case 'percentage':
          this.score2Text = this.progress2 + '%'
          break
        default:
          this.score2Text = 'Unsupported displayAs'
          break
      }
    }
  },
  watch: {
    result: function (result, oldResult) {
      this.update()
    }
  }
}
</script>
<style lang='scss'>
@import '../scss/components/result_compare';
.result-circles {
  margin:auto;
  width: 50%;
  max-width: 600px;
  display: flex;
  justify-content: space-between;
}
.result-spacer {
  & > div {
    width: 60px;
    border: 1px solid #ccc;
    border-radius: 50%;
    height: 60px;
    margin-top: 60px;
  }
}
.result-message {
  p {
    margin-top: 0;
  }
}
.debug {
  h2 {
    margin-top: 0;
  }
  background-color: #efefef;
  border: 1px solid #ccc;
  padding: 20px;
}
</style>
